import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
  background-color: ${({ theme }) => theme.color.background.neutral.weak};
  padding: ${({ theme }) => theme.spacing.km4}
    ${({ theme }) => theme.spacing.km6};
  border-radius: ${({ theme }) => theme.border.radius.large};
  width: 100%;
`;

export const Container = styled.div`
  width: 96%;
  overflow-wrap: break-word;
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.color.text.neutral.strong};
  font-family: ${({ theme }) => theme.font.family.heading};
  font-size: ${({ theme }) => theme.font.size.m3};
  margin-left: ${({ theme }) => theme.spacing.km4};
  flex: 1;
`;

export const Wrap = styled(Container)`
  width: 93%;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Item = styled.li`
  color: ${({ theme }) => theme.color.text.neutral.weak};
  font-family: ${({ theme }) => theme.font.family.heading};
  font-size: ${({ theme }) => theme.font.size.m3};
  margin-left: ${({ theme }) => theme.spacing.km4};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-left: ${({ theme }) => theme.spacing.km10};
  }
`;
